import { Box, Typography, useTheme, styled } from '@mui/material'
import { Icon } from '../../eid-icons'
import { useTranslation } from 'react-i18next'

const FilterContainer = styled(Box)({
    marginBottom: '2.8rem',
})

const CollapsibleFilterPanel = ({ openFilters, setOpenFilters }) => {
    const { t } = useTranslation()
    const theme = useTheme()
    return (
        <FilterContainer>
            <Box
                display="flex"
                alignItems="center"
                sx={{
                    height: '4rem',
                    borderBottom: '.1rem solid #d8d8d8',
                }}
            >
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        gap: '.8rem',
                        alignItems: 'center',
                    }}
                >
                    {' '}
                    <Icon name="FilterBar" color="#959598" />
                    <Typography
                        sx={{
                            fontWeight: '700',
                            fontSize: '1.8rem',
                            color: '#3b454d',
                        }}
                    >
                        {t('Filters')}
                    </Typography>
                </Box>
                <Box>
                    <Box
                        component="span"
                        display="flex"
                        sx={{
                            textTransform: 'uppercase',
                            zIndex: 9999,
                            marginTop: '0.2rem',
                            color: '#0057A0',
                            fontSize: '1.2rem',
                            fontWeight: '600',
                            '&:hover': {
                                cursor: 'pointer',
                            },
                        }}
                        onClick={setOpenFilters}
                    >
                        {openFilters ? t('Hide') : t('Show')}
                        <Box
                            sx={{
                                width: '1.6rem',
                                height: '1.6rem',
                                marginLeft: '0.8rem',
                                borderRadius: '50%',
                                border: `0.1rem solid ${theme?.palette?.primary?.main}`,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                color: theme?.palette?.primary?.main,
                                lineHeight: '0',
                                fontSize: '1.5rem',
                            }}
                        >
                            {openFilters ? '-' : '+'}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </FilterContainer>
    )
}

export default CollapsibleFilterPanel
